import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=2204df48&"
import script from "./MoneyInput.vue?vue&type=script&lang=js&"
export * from "./MoneyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MoneyInput.vue"
export default component.exports